// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ReplyAll = React.forwardRef(function ReplyAll(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ReplyAll" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2071 16.5304L7.85352 10.1768L14.2071 3.82324L15.9809 5.59705L12.6418 8.9268L19.25 8.92698C20.4926 8.92698 21.5 9.93434 21.5 11.177V20H19V11.427L12.6418 11.4268L15.9809 14.7566L14.2071 16.5304ZM9.62735 14.758L7.85355 16.5318L1.5 10.1783L7.85355 3.82471L9.62735 5.59851L5.86258 9.3528L5.08554 10.1726L5.86319 11.0043L9.62735 14.758Z", fill: "currentColor" }))));
});
ReplyAll.displayName = 'ReplyAll';
export default ReplyAll;
//# sourceMappingURL=ReplyAll.js.map